import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { T } from '~/components/I18n';
import { Tabs } from '~/components/Tab/Tabs';
import tabStyles from '~/components/Tab/Tabs.module.scss';
import styles from './ChallengeTabs.module.scss';

export type ChallengeTabsProps = {
  className?: string;
};

export const ChallengeTabs = ({ className }: ChallengeTabsProps) => (
  <Tabs variant="underline" className={classNames(styles.root, className)}>
    <li>
      <NavLink
        to={{ pathname: '/challenge', state: { scroll: 'restore' } }}
        className={styles.tab}
        exact
        replace
        activeClassName={tabStyles.active}
        data-event="click"
        data-event-target="reward_in_challengehistory">
        <T name="citizen_challenge_history_menu1" />
      </NavLink>
    </li>
    <li>
      <NavLink
        to={{ pathname: '/challenge/purchase', state: { scroll: 'restore' } }}
        className={styles.tab}
        replace
        activeClassName={tabStyles.active}
        data-event="click"
        data-event-target="score_in_challengehistory">
        <T name="citizen_challenge_history_menu2" />
      </NavLink>
    </li>
    <li>
      {/* TODO: Add GA attributes */}
      <NavLink
        to={{ pathname: '/challenge/score', state: { scroll: 'restore' } }}
        className={styles.tab}
        replace
        activeClassName={tabStyles.active}
        data-event="click"
        data-event-target="scoreup_in_challengehistory">
        <T name="citizen_challenge_scoreup_name" />
      </NavLink>
    </li>
  </Tabs>
);
